import { createPortal } from "react-dom";

const rootElementForModals = document.getElementById("root-modals");

export const ModalOnPortal = ({ children }) => {
  return createPortal(children, rootElementForModals);
};
